import { ThemeEvents } from '@theme/events';

const SUBSCRIPTION_DISCOUNT = 0.2;

let product = null;

/* ----------------------------------------------------------
   PRECOMPUTED PRICE MATRIX
---------------------------------------------------------- */

let priceMatrix = {};
let optionCount = 0;

function buildPriceMatrix(product){

  optionCount = product.options.length;
  
  product.variants.forEach(v=>{

    const key = v.options.join('|');

    priceMatrix[key] = {
      price: v.price,
      compare: v.compare_at_price || null,
      price_subscription: v.selling_plan_allocations[0]?.price || v.price,
      compare_subscription: v.selling_plan_allocations[0]?.compare_at_price || v.compare_at_price || null
    };

  });

}

/* ----------------------------------------------------------
   MONEY FORMAT
---------------------------------------------------------- */

function money(cents){

  if(window.Currency?.formatMoney){
    return window.Currency.formatMoney(cents);
  }

  if(window.Shopify?.formatMoney){
    return window.Shopify.formatMoney(cents);
  }

  return new Intl.NumberFormat(undefined,{
    style:'currency',
    currency: Shopify.currency.active || 'USD'
  }).format(cents/100);

}

/* ----------------------------------------------------------
   PRICE ENGINE
---------------------------------------------------------- */

function computePrice(base,compare,subscription){

  let finalPrice = base;
  let finalCompare = null;
  
  if(subscription){

    finalPrice = base;

    /* compare price khi subscription luôn là giá gốc */
    finalCompare = compare;

  } else{

    /* restore compare_at_price thật của variant */

    if(compare){
      finalCompare = compare;
    }
  }

  return { finalPrice, finalCompare };

}

/* ----------------------------------------------------------
   DOM CACHE (0 query after init)
---------------------------------------------------------- */

let blocks = [];

function buildDomCache(root){

  const nodes = root.querySelectorAll('[data-variant-price]');

  blocks = Array.from(nodes).map(node=>{

    const label = node.closest('label');
    const input = label?.querySelector('input');

    return {
      node,
      input,
      priceEl: node.querySelector('.price'),
      compareEl: node.querySelector('.compare-at-price')
    };

  });

}

/* ----------------------------------------------------------
   SUBSCRIPTION
---------------------------------------------------------- */

function isSubscription(){

  const w = document.querySelector('.kaching-subscriptions__widget');

  if(!w) return false;

  return !w.classList.contains('one-time-purchase-selected');

}

/* ----------------------------------------------------------
   CURRENT OPTIONS
---------------------------------------------------------- */

function getOptions(root){

  const opts = new Array(optionCount);

  product.options.forEach((_,i)=>{

    const pos = i+1;

    const el = root.querySelector(
      `[data-input-id^="${pos}-"]:checked`
    );

    if(el) opts[i]=el.value;

  });

  return opts;

}

/* ----------------------------------------------------------
   FAST MATRIX LOOKUP
---------------------------------------------------------- */

function getVariantPrice(options){

  return priceMatrix[options.join('|')];

}

/* ----------------------------------------------------------
   UPDATE BLOCK
---------------------------------------------------------- */

function updateBlock(block,price,compare,subscription){

  const {finalPrice,finalCompare} =
    computePrice(price,compare,subscription);

  block.priceEl.textContent = money(finalPrice);

  if(finalCompare){    
    if(!block.compareEl){

      block.compareEl = document.createElement('span');
      block.compareEl.className = 'compare-at-price';

      block.priceEl.after(block.compareEl);

    }

    block.compareEl.textContent = money(finalCompare);
    block.compareEl.style.display='';

  }else if(block.compareEl){
    block.compareEl.style.display='none';
  }

}

/* ----------------------------------------------------------
   UPDATE ENGINE
---------------------------------------------------------- */

function update(root){

  const subscription = isSubscription();

  const currentOpts = getOptions(root);
  
  
  blocks.forEach(b=>{
    
    if(!b.input) return;
    
    const id = b.input.dataset.inputId;
    if(!id) return;
    
    const [pos] = id.split('-');
    
    const opts=[...currentOpts];
    
    opts[pos-1]=b.input.value;
    
    const v = getVariantPrice(opts);
    let price = v?.price;
    if (subscription) price = v?.price_subscription;

    if(!v) return;

    updateBlock(b,price,v.compare,subscription);

  });

}

/* ----------------------------------------------------------
   INTERSECTION OBSERVER
---------------------------------------------------------- */

function lazyInit(root){

  const observer = new IntersectionObserver(entries=>{

    entries.forEach(e=>{

      if(e.isIntersecting){
        update(root);
        observer.disconnect();

      }

    });

  });

  observer.observe(root);

}

/* ----------------------------------------------------------
   SUBSCRIPTION OBSERVER
---------------------------------------------------------- */

function observeSubscription(root){

  const w=document.querySelector('.kaching-subscriptions__widget');

  if(!w) return;

  const mo = new MutationObserver(()=>update(root));

  mo.observe(w,{
    attributes:true,
    attributeFilter:['class']
  });

}

/* ----------------------------------------------------------
   CURRENCY SWITCHER
---------------------------------------------------------- */

function observeCurrency(root){

  document.addEventListener('currency:change',()=>{

    update(root);

  });

}

/* ----------------------------------------------------------
   INIT
---------------------------------------------------------- */

function init(){

  const root=document.querySelector('variant-picker');
  if(!root) return;

  const script=document.getElementById('ProductJson');
  if(!script) return;

  product=JSON.parse(script.textContent);

  buildPriceMatrix(product);

  buildDomCache(root);

  lazyInit(root);

  root.addEventListener('change',()=>update(root));

  document.addEventListener(
    ThemeEvents.variantUpdate,
    ()=>update(root)
  );

  observeSubscription(root);

  observeCurrency(root);

}

/* ----------------------------------------------------------
   SHOPIFY SECTION SAFE
---------------------------------------------------------- */

document.addEventListener('DOMContentLoaded',init);

document.addEventListener('shopify:section:load',init);